import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaServer, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

const ServerStatus = () => {
  const [status, setStatus] = useState({
    connected: false,
    message: 'Checking server connection...',
    serverPort: 'Unknown',
    error: null,
    loading: true
  });

  useEffect(() => {
    const checkServerConnection = async () => {
      try {
        // Make a request to the backend health check endpoint
        const response = await axios.get('/api/health');
        
        setStatus({
          connected: true,
          message: 'Connected to server successfully!',
          serverPort: response.data.port || '4000',
          error: null,
          loading: false
        });
      } catch (error) {
        console.error('Server connection error:', error);
        
        setStatus({
          connected: false,
          message: 'Failed to connect to server',
          serverPort: 'Unknown',
          error: error.message || 'Unknown error',
          loading: false
        });
      }
    };

    checkServerConnection();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <FaServer className="mx-auto h-12 w-12 text-blue-600" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Server Status</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Checking connection to backend server on port 4000
          </p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-md">
          {status.loading ? (
            <div className="text-center">
              <div className="spinner animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
              <p className="mt-4 text-gray-700">Checking connection...</p>
            </div>
          ) : status.connected ? (
            <div className="text-center">
              <FaCheckCircle className="mx-auto h-12 w-12 text-green-500" />
              <h3 className="mt-4 text-xl font-medium text-gray-900">Connection Successful</h3>
              <p className="mt-2 text-green-600">{status.message}</p>
              <div className="mt-4 p-3 bg-gray-50 rounded-md">
                <p className="text-sm text-gray-700">
                  <span className="font-medium">Server Port:</span> {status.serverPort}
                </p>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <FaExclamationTriangle className="mx-auto h-12 w-12 text-red-500" />
              <h3 className="mt-4 text-xl font-medium text-gray-900">Connection Failed</h3>
              <p className="mt-2 text-red-600">{status.message}</p>
              {status.error && (
                <div className="mt-4 p-3 bg-red-50 rounded-md">
                  <p className="text-sm text-red-700">
                    <span className="font-medium">Error:</span> {status.error}
                  </p>
                </div>
              )}
              <div className="mt-4 p-3 bg-gray-50 rounded-md">
                <p className="text-sm text-gray-700">
                  Make sure your backend server is running on port 4000
                </p>
              </div>
            </div>
          )}
        </div>
        
        <div className="text-center mt-4">
          <Link
            to="/"
            className="font-medium text-blue-600 hover:text-blue-500"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServerStatus; 